export default __webpack_public_path__ + "src/assets/connatix_logo.png";